import * as React from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReceiptLong } from '@mui/icons-material';

const ActionsBar = ({ title, subTitle, addButtonTitle, onAddPress }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                height: 80,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                textAlign: isMobile ? 'center' : 'left',
            }}
        >
            <Box
                sx={{
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    mb: isMobile ? 1 : 0,
                    flex: 1
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        color: 'black',
                        alignItems: 'flex-start'
                    }}
                >
                    <span
                        style={{
                            color: 'black',
                            fontSize: isMobile ? '14px' : '18px',
                            fontWeight: 'bold',
                        }}
                    >
                        {title}
                    </span>
                    <span
                        style={{
                            color: 'black',
                            fontSize: isMobile ? '10px' : '12px',
                            marginTop: 5,
                        }}
                    >
                        {subTitle}
                    </span>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: isMobile ? 'center' : 'flex-end',
                }}
            >
                {addButtonTitle && (
                    <Button
                        sx={{
                            fontSize: isMobile ? '14px' : '16px',
                        }}
                        onClick={() => onAddPress && onAddPress()}
                    >
                        {addButtonTitle}
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default ActionsBar;